import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { Auth } from 'aws-amplify'
import { addError } from '@/contexts/errors/errors'
import {
  createClientError,
  createServerError
} from '@/contexts/errors/api.errors'
import { getClientId } from '@/lib/client'

export async function authHeader(
  config: AxiosRequestConfig
): Promise<AxiosRequestConfig> {
  const session = await Auth.currentSession()
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${session.getIdToken().getJwtToken()}`
  }
  return config
}

export async function clientIdParam(
  config: AxiosRequestConfig
): Promise<AxiosRequestConfig> {
  const clientId = await getClientId()
  config.params = {
    clientId: clientId,
    ...config.params
  }
  return config
}

export function errorHandler(response: AxiosResponse): AxiosResponse {
  if (typeof response === 'undefined') {
    addError(
      createServerError(
        502,
        'Network Error',
        'Could not connect to server, this is most likely a CORS error.'
      )
    )
  } else {
    const clientError = response.status >= 400 && response.status < 500
    const serverError = response.status >= 500
    if (clientError) {
      addError(
        createClientError(response.status, response.statusText, response.data)
      )
    } else if (serverError) {
      addError(
        createServerError(response.status, response.statusText, response.data)
      )
    }
  }
  return response
}
